import { useEffect, useState } from "react";

type UsePaginationPagesHook = {
  pages: number[];
  numberOfPages: number;
};

export const usePaginationPages = (
  totalItems: number,
  pageSize: number,
  currentPage: number
): UsePaginationPagesHook => {
  const [pages, setPages] = useState<number[]>([]);
  const [numberOfPages, setNumberOfPages] = useState<number>(0);

  useEffect(() => {
    const totalNumberOfPages = Math.ceil(totalItems / pageSize);
    setNumberOfPages(totalNumberOfPages);
    setPages(getPagesToDisplay(totalNumberOfPages, currentPage));
  }, [totalItems, pageSize, currentPage]);

  return {
    pages,
    numberOfPages,
  };
};

function getPagesToDisplay(totalNumberOfPages: number, currentPage: number): number[] {
  if (totalNumberOfPages <= 5) {
    return Array.from({ length: totalNumberOfPages }, (_, i) => i + 1);
  }
  const firstThreePages = [1, 2, 3];
  if (firstThreePages.includes(currentPage)) {
    return [...firstThreePages, 4, totalNumberOfPages];
  }
  const lastThreePages = [totalNumberOfPages - 2, totalNumberOfPages - 1, totalNumberOfPages];
  if (lastThreePages.includes(currentPage)) {
    return [1, totalNumberOfPages - 3, ...lastThreePages];
  }
  return [1, currentPage - 1, currentPage, currentPage + 1, totalNumberOfPages];
}
